export async function frameBarrier() {
    await new Promise(resolve => {
        requestAnimationFrame(() => {
            requestAnimationFrame(() => resolve());
        })
    });
}

export async function transitionBarrier(el) {
    let end, cancel;
    await new Promise((resolve, reject) => {
        end = () => resolve();
        cancel = () => reject();
        el.addEventListener("transitionend", end);
        el.addEventListener("transitioncancel", cancel);
    });

    el.removeEventListener("transitionend", end);
    el.removeEventListener("transitioncancel", cancel);
}
